export default () => ({
  show: false,
  loading: false,

  init() {
    // Quick shop initialization
  },

  // Helper method to reinitialize wishlist buttons
  reinitializeWishlist() {
    document.dispatchEvent(new CustomEvent("shopify-wishlist:init"));
  },

  close() {
    this.show = false;

    const originUrl = Alpine.store("nostoState")?.data?.originUrl;

    // Restore the original URL from Nosto state
    if (originUrl) {
      window.history.replaceState(null, "", originUrl);
    }

    if (document.body.classList.contains("body-outfit-pdp")) {
      document.body.classList.remove("body-outfit-pdp");
    }
  },

  open() {
    this.show = true;

    // 🛍️ QUICK SHOP DEBUG - Modal Opened
    // console.group("🛍️ QUICK SHOP MODAL OPENED");
    // console.log("👁️ Modal State:", {
    //   isVisible: true,
    //   openedAt: new Date().toISOString(),
    //   scrollLocked: true,
    //   country: window.Shopify?.country || "Unknown",
    //   currency: window.Shopify?.currency?.active || "Unknown",
    //   currencyCode: window.Shopify?.currency?.code || "Unknown",
    //   locale: window.Shopify?.locale || "Unknown",
    // });
    // console.groupEnd();
  },

  toggle() {
    const show = !this.show;
    if (show) {
      this.open();
    } else {
      this.close();
    }
  },

  extractProductHandle(productIdentifier) {
    if (productIdentifier.includes("/products/")) {
      const match = productIdentifier.match(/\/products\/([^\/\?]+)/);
      return match?.[1] || productIdentifier;
    }
    return productIdentifier;
  },

  async handleQuickShopEvent(productIdentifier) {
    if (!productIdentifier) {
      console.warn("🛍️ QuickShop event received without product identifier");
      return;
    }

    const productHandle = this.extractProductHandle(productIdentifier);

    // Get Nosto state data and update store
    const nostoState = Alpine.store("nostoState")?.data;
    if (Alpine.store("nostoState")) {
      const newState = {
        ...nostoState,
        productUrl: productIdentifier,
        originUrl: window.location.href,
      };

      Alpine.store("nostoState").set(newState);
    } else {
      console.warn("Nosto store not found!");
    }

    // Trigger Nosto View Product event
    if (nostoState?.attributionKey && typeof nostojs === "function") {
      nostojs((api) => {
        api
          .createRecommendationRequest()
          .setProducts(
            [{ product_id: nostoState.productId }],
            nostoState.attributionKey
          )
          .load({ skipPageViews: true });
      });
    } else {
      console.warn("Cannot trigger Nosto event:", {
        hasAttributionKey: !!nostoState?.attributionKey,
        hasProductId: !!nostoState?.productId,
        nostojsExists: typeof nostojs === "function",
        nostoState: nostoState,
      });
    }

    // Always load fresh content to ensure correct pricing
    await this.loadProductInModal(productHandle);
  },

  handleCloseEvent() {
    this.close();
  },

  async loadProductInModal(productHandle) {
    this.loading = true;

    try {
      // Use Section Rendering API to load the new product
      const url = `${window.Shopify.routes.root}products/${productHandle}?section_id=quick-shop-product`;

      const response = await fetch(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();

      // Clear any previous content and load new product
      const modalBody = document.querySelector(
        ".quick-shop-modal .no-scrollbar"
      );
      if (modalBody) {
        modalBody.innerHTML = html;

        // Update the URL in the browser without navigating (optional)
        const newUrl = `${window.Shopify.routes.root}products/${productHandle}`;
        window.history.pushState({}, "", newUrl);
      }

      // Reinitialize wishlist buttons after content is loaded
      this.reinitializeWishlist();

      // Open modal after content is loaded
      this.open();
    } catch (error) {
      console.error("Error loading new product in modal:", error);
      // Show error message to user
      const modalBody = document.querySelector(
        ".quick-shop-modal .no-scrollbar"
      );
      if (modalBody) {
        modalBody.innerHTML = `
          <div class="p-16 text-center">
            <p class="text-red-600">Error loading product. Please try again.</p>
          </div>
        `;
      }
      // Don't open modal on error
    } finally {
      this.loading = false;
    }
  },

  // Add method for variant selection within quick-shop (from old setup)
  quickShopVariantSelect(productUrl) {
    fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        const productElement = responseHTML.querySelector(
          ".quick-shop-product-section"
        );

        if (productElement) {
          this.preventDuplicatedIDs(productElement);
          this.removeDOMElements(productElement);
          const modalBody = document.querySelector(
            ".quick-shop-modal .no-scrollbar"
          );
          if (modalBody) modalBody.innerHTML = "";
          this.setInnerHTML(modalBody, productElement.innerHTML);
        }

        // Reinitialize wishlist buttons after content is loaded
        this.reinitializeWishlist();

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.preventVariantURLSwitching(
          document.querySelector(".quick-shop-modal .no-scrollbar")
        );
      })
      .catch((error) => {
        console.error("Error fetching variant:", error);
      });
  },

  // Helper methods from old setup
  setInnerHTML(element, html) {
    if (!element) return;

    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  },

  preventVariantURLSwitching(opener) {
    if (!opener) return;

    const variantElements = opener.querySelectorAll(
      "variant-radios, variant-selects"
    );
    variantElements.forEach((element) => {
      element.setAttribute("data-update-url", "false");
    });
  },

  removeDOMElements(productElement) {
    if (!productElement) return;

    const pickupAvailability = productElement.querySelector(
      "pickup-availability"
    );
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = productElement.querySelector("product-modal");
    if (productModal) productModal.remove();
  },

  preventDuplicatedIDs(productElement) {
    if (!productElement) return;

    const sectionId = productElement.dataset.section;
    if (sectionId) {
      productElement.innerHTML = productElement.innerHTML.replaceAll(
        sectionId,
        `quickadd-${sectionId}`
      );
      productElement
        .querySelectorAll("variant-selects, variant-radios")
        .forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
        });
    }
  },
});
